export default __webpack_public_path__ + "static/media/61.62ca38b3.png";